<template>
  <div class="carrousel-container overflow-hidden py-2 px-4 px-md-0">
    <cycle-carousel class="cycle-carousel">
      <CycleTimeIcon
        v-for="(loop_cycle, index) in cycles"
        :key="index"
        class="d-flex justify-content-center align-items-center"
        :cycle="loop_cycle"
        @click="loop_cycle.disabled && authUser.is_student ? '' : onClick(loop_cycle)"
      />
      <CycleTimeIcon
        v-if="showAll"
        :cycle="{}"
        @click="onClickAll"
      >
        Todos
        <template #tooltip>
          Ver todos
        </template>
      </CycleTimeIcon>
    </cycle-carousel>
  </div>
</template>
<script>
import CycleTimeIcon from "./CycleTimeIcon";
import { mapGetters, mapMutations} from "vuex";

export default {
  components: {CycleTimeIcon},
  props: {
    showAll: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['cycles','authUser']),
  },
  methods: {
    ...mapMutations(['SET_CYCLE']),
    onClickAll() {
      this.SET_CYCLE(null);
    },
    onClick(cycle) {
      this.SET_CYCLE(cycle);
      this.$emit('input', cycle)
    },
  }
}
</script>
<style scoped>
  .carousel-container {
    position: relative;
  }
</style>


